import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

const AutenticationCheck = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');

  React.useEffect(() => {
    if (!token) {
      navigate('/auths/auth-login');
    }
  }, [token, navigate]);

  return token ? <Outlet /> : null;
};

export default AutenticationCheck;
